import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import RadioGroup from '../../../../../web-ui-library/src/components/RadioGroup/RadioGroup';
import { Typography, Button } from '@navi/web-ui/lib/primitives';
import InfoIcon from '@navi/web-ui/lib/icons/InfoIcon';
import styles from './PIIAcknowledgmentModal.module.scss';
import Modal from '@cp/src/components/Modal/Modal';
import { PIIForm } from './types';
import { piiAcknowledgmentText, reasonOptions } from './const';

interface PIIAcknowledgmentModalProps {
  visible: boolean;
  onClose: () => void;
  onAgree: (reason: string) => void;
}

const PIIAcknowledgmentModal: React.FC<PIIAcknowledgmentModalProps> = ({
  visible,
  onClose,
  onAgree
}) => {
  const {
    control,
    handleSubmit,
    formState: { isValid }
  } = useForm<PIIForm>({
    mode: 'onChange',
    defaultValues: { reason: '' }
  });

  const onSubmit = (data: PIIForm) => {
    onAgree(data.reason);
  };

  const modalHeader = (
    <div className={styles.headerWrapper}>
      <InfoIcon height={24} width={24} color="var(--navi-color-orange-base)" />
      <Typography variant="h4" color="var(--navi-color-gray-c1)">
        {piiAcknowledgmentText.header}
      </Typography>
    </div>
  );

  return (
    <Modal
      visible={visible}
      header={modalHeader}
      onClose={onClose}
      closeOnOutsideClick={false}
      showCloseIcon={false}
      contentClassName={styles.modalContent}
      contentWrapperClass={styles.modalWrapper}
    >
      <div className={styles.acknowledgmentContainer}>
        <div className={styles.warningBox}>
          <Typography variant="p4" color={'var(--navi-color-gray-c2)'}>
            {piiAcknowledgmentText.disclaimer}
          </Typography>
        </div>

        <div className={styles.reasonSection}>
          <Typography variant="h4" className={styles.reasonTitle}>
            {piiAcknowledgmentText.reasonTitle}
          </Typography>

          <Controller
            name="reason"
            control={control}
            rules={{ required: 'Please select a reason' }}
            render={({ field }) => (
              <RadioGroup
                name="pii-reason"
                options={reasonOptions}
                value={field.value}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  field.onChange(e.target.value)
                }
                optionType={'chip'}
              />
            )}
          />
        </div>

        <div className={styles.buttonContainer}>
          <Button variant="secondary" onClick={onClose} className="w-[206px] h-12">
            <Typography variant="p3" color="var(--navi-color-gray-c2)">
              Cancel
            </Typography>
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit(onSubmit)}
            className="w-[206px] h-12"
            disabled={!isValid}
          >
            <Typography variant="p3" color="var(--navi-color-gray-bg-primary)">
              Agree and continue
            </Typography>
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PIIAcknowledgmentModal;
